<template>
  <HourlyChauffeurRate />
</template>
<script>
import HourlyChauffeurRate from "@/components/master/hourlyTariff/HourlyChauffeurRate";
export default {
  components: {
    HourlyChauffeurRate,
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("buying-rental-chauffeur-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/buyingTariff/HourlyChauffeurRateBuying.vue